import axios from '../plugins/axios'

export default {
    create(params){
      return axios.post('/api/v1/action_logs/create', params)
    },
}
